export const STAFF_PICKS_SURFACE_KEY = "back-display";

// Exact face order requested for the entrance experience. The first five
// surfaces occupy most of the view immediately after passing the noren.
const FACE_LOAD_ORDER: ReadonlyArray<number | typeof STAFF_PICKS_SURFACE_KEY> = [
  1,
  3,
  5,
  7,
  STAFF_PICKS_SURFACE_KEY,
  8,
  9,
  0,
  2,
  4,
  6,
];

const FACE_LOAD_PRIORITY = new Map(
  FACE_LOAD_ORDER.map((face, priority) => [face, priority]),
);

export function shelfFaceLoadPriority(sectionIndex: number, surfaceKey: string): number {
  const face = surfaceKey === STAFF_PICKS_SURFACE_KEY ? STAFF_PICKS_SURFACE_KEY : sectionIndex;
  return FACE_LOAD_PRIORITY.get(face) ?? FACE_LOAD_ORDER.length;
}
